import { render } from "./WideHighlightContainer.vue?vue&type=template&id=a7afeae0&scoped=true"
import script from "./WideHighlightContainer.vue?vue&type=script&lang=js"
export * from "./WideHighlightContainer.vue?vue&type=script&lang=js"

import "./WideHighlightContainer.vue?vue&type=style&index=0&id=a7afeae0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7afeae0"]])

export default __exports__